export function httpGetAsync(theUrl, success, error) {
    const xmlHttp = new XMLHttpRequest()

    xmlHttp.onreadystatechange = () => { 
      if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
        success(xmlHttp.responseText)
      } else {
        error()
      }
    }

    xmlHttp.open("GET", theUrl, true)
    xmlHttp.send(null)
}

export function parseUrlParameters(url) {
  let parsed = {}

  if (url) {
    (url.split('?')[1] || url)
      .split('&')
      .map((item) => item.split('='))
      .forEach((item) => parsed[item[0]] = item[1])
  }

  return parsed
}


export function getLocalizedPage(contentfulPage, lang) {
  return contentfulPage.edges
    .map(edge => edge.node)
    .filter(node => node.node_locale === lang)[0]
}


export const isDomElement = (element, targetElement) => {
  if (element == targetElement) {
    return true
  } else if (element == document.body) {
    return false
  } else {
    return isDomElement(element.parentNode, targetElement)
  }
}


export const isColorBackground = (backgroundColor) => {
  if (!backgroundColor) {
    return false
  }

  const color = backgroundColor.toLowerCase()

  return color !== '#ffffff' && color !== '#fff' && color !== 'white'
}


export const traverse = (content, callback) => {
  function traverseObject(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        _traverse(key, obj[key], callback)
      }
    }
  }
  
  function isArray(o) {
    return Object.prototype.toString.call(o) === '[object Array]'
  }

  function _traverse(key, value, callback) {
    if (isArray(value)) {
      value.forEach(x => _traverse(null, x, callback))
    } else if ((typeof value === 'object') && (value !== null)) {
      traverseObject(value)
    } else if ((typeof value === 'string')) {
      results.push({key, value})
    }
  }

  const results = []
  _traverse(null, content, callback)

  return results
}


// WEBPACK FOOTER //
// ./src/util.js